import styled from 'styled-components'

const spacing = 0.5 // spacing unit in rem

const resolveSpacing = value =>
  typeof value === 'number' ? `${value * spacing}rem` : undefined

const Box = styled.div`
  display: ${props => props.displayBox || 'block'};

  /* Margin */
  margin-top: ${props => resolveSpacing(props.mt ?? props.my ?? props.m)};
  margin-right: ${props => resolveSpacing(props.mr ?? props.mx ?? props.m)};
  margin-bottom: ${props => resolveSpacing(props.mb ?? props.my ?? props.m)};
  margin-left: ${props => resolveSpacing(props.ml ?? props.mx ?? props.m)};

  /* Padding */
  padding-top: ${props => resolveSpacing(props.pt ?? props.py ?? props.p)};
  padding-right: ${props => resolveSpacing(props.pr ?? props.px ?? props.p)};
  padding-bottom: ${props => resolveSpacing(props.pb ?? props.py ?? props.p)};
  padding-left: ${props => resolveSpacing(props.pl ?? props.px ?? props.p)};
`

export default Box
